import orderBy from "lodash.orderby";
import { specialCharactersRegex } from "./regex";

export type State = {
  name: string;
  abbreviation?: string;
  code?: string;
};

export interface AvailableStates {
  [key: string]: State[];
}
const usStates: State[] = [
  {
    name: "Alabama",
    code: "AL"
  },
  {
    name: "Alaska",
    code: "AK"
  },
  {
    name: "Arizona",
    code: "AZ"
  },
  {
    name: "Arkansas",
    code: "AR"
  },
  {
    name: "California",
    code: "CA"
  },
  {
    name: "Colorado",
    code: "CO"
  },
  {
    name: "Connecticut",
    code: "CT"
  },
  {
    name: "Delaware",
    code: "DE"
  },
  {
    name: "District Of Columbia",
    code: "DC"
  },
  {
    name: "Florida",
    code: "FL"
  },
  {
    name: "Georgia",
    code: "GA"
  },
  {
    name: "Hawaii",
    code: "HI"
  },
  {
    name: "Idaho",
    code: "ID"
  },
  {
    name: "Illinois",
    code: "IL"
  },
  {
    name: "Indiana",
    code: "IN"
  },
  {
    name: "Iowa",
    code: "IA"
  },
  {
    name: "Kansas",
    code: "KS"
  },
  {
    name: "Kentucky",
    code: "KY"
  },
  {
    name: "Louisiana",
    code: "LA"
  },
  {
    name: "Maine",
    code: "ME"
  },
  {
    name: "Maryland",
    code: "MD"
  },
  {
    name: "Massachusetts",
    code: "MA"
  },
  {
    name: "Michigan",
    code: "MI"
  },
  {
    name: "Minnesota",
    code: "MN"
  },
  {
    name: "Mississippi",
    code: "MS"
  },
  {
    name: "Missouri",
    code: "MO"
  },
  {
    name: "Montana",
    code: "MT"
  },
  {
    name: "Nebraska",
    code: "NE"
  },
  {
    name: "Nevada",
    code: "NV"
  },
  {
    name: "New Hampshire",
    code: "NH"
  },
  {
    name: "New Jersey",
    code: "NJ"
  },
  {
    name: "New Mexico",
    code: "NM"
  },
  {
    name: "New York",
    code: "NY"
  },
  {
    name: "North Carolina",
    code: "NC"
  },
  {
    name: "North Dakota",
    code: "ND"
  },
  {
    name: "Ohio",
    code: "OH"
  },
  {
    name: "Oklahoma",
    code: "OK"
  },
  {
    name: "Oregon",
    code: "OR"
  },
  {
    name: "Pennsylvania",
    code: "PA"
  },
  {
    name: "Rhode Island",
    code: "RI"
  },
  {
    name: "South Carolina",
    code: "SC"
  },
  {
    name: "South Dakota",
    code: "SD"
  },
  {
    name: "Tennessee",
    code: "TN"
  },
  {
    name: "Texas",
    code: "TX"
  },
  {
    name: "Utah",
    code: "UT"
  },
  {
    name: "Vermont",
    code: "VT"
  },
  {
    name: "Virginia",
    code: "VA"
  },
  {
    name: "Washington",
    code: "WA"
  },
  {
    name: "West Virginia",
    code: "WV"
  },
  {
    name: "Wisconsin",
    code: "WI"
  },
  {
    name: "Wyoming",
    code: "WY"
  }
];

const gbStates: State[] = [
  {
    code: "AA",
    name: "Aberconwy and Colwyn"
  },
  {
    code: "AB",
    name: "Aberdeen City"
  },
  {
    code: "AC",
    name: "Aberdeenshire"
  },
  {
    code: "AD",
    name: "Anglesey"
  },
  {
    code: "AE",
    name: "Angus"
  },
  {
    code: "AF",
    name: "Antrim"
  },
  {
    code: "AG",
    name: "Argyll"
  },
  {
    code: "AH",
    name: "Argyll and Bute"
  },
  {
    code: "AI",
    name: "Armagh"
  },
  {
    code: "AJ",
    name: "Avon"
  },
  {
    code: "AK",
    name: "Ayrshire"
  },
  {
    code: "BA",
    name: "Banffshire"
  },
  {
    code: "BB",
    name: "Barking And Dagenham"
  },
  {
    code: "BC",
    name: "Barnet"
  },
  {
    code: "BD",
    name: "Barnsley"
  },
  {
    code: "BE",
    name: "Bath and NE Somerset"
  },
  {
    code: "BF",
    name: "Bath And North East Somerset"
  },
  {
    code: "BG",
    name: "Bedford"
  },
  {
    code: "BH",
    name: "Bedfordshire"
  },
  {
    code: "BI",
    name: "Belfast"
  },
  {
    code: "BJ",
    name: "Berkshire"
  },
  {
    code: "BK",
    name: "Berwickshire"
  },
  {
    code: "BL",
    name: "Bexley"
  },
  {
    code: "BM",
    name: "BFPO"
  },
  {
    code: "BN",
    name: "Birmingham"
  },
  {
    code: "BO",
    name: "Blackburn With Darwen"
  },
  {
    code: "BP",
    name: "Blackpool"
  },
  {
    code: "BQ",
    name: "Blaenau Gwent"
  },
  {
    code: "BR",
    name: "Bolton"
  },
  {
    code: "BS",
    name: "Bournemouth"
  },
  {
    code: "BT",
    name: "Bracknell Forest"
  },
  {
    code: "BU",
    name: "Bradford"
  },
  {
    code: "BV",
    name: "Brecknockshire"
  },
  {
    code: "BW",
    name: "Brent"
  },
  {
    code: "BX",
    name: "Bridgend"
  },
  {
    code: "BY",
    name: "Brighton And Hove"
  },
  {
    code: "BZ",
    name: "Bristol, City Of"
  },
  {
    code: "B0",
    name: "Bromley"
  },
  {
    code: "B1",
    name: "Buckinghamshire"
  },
  {
    code: "B2",
    name: "Bury"
  },
  {
    code: "CA",
    name: "Caernarfonshire"
  },
  {
    code: "CB",
    name: "Caerphilly"
  },
  {
    code: "CC",
    name: "Caithness"
  },
  {
    code: "CD",
    name: "Calderdale"
  },
  {
    code: "CE",
    name: "Cambridgeshire"
  },
  {
    code: "CF",
    name: "Camden"
  },
  {
    code: "CG",
    name: "Cardiff"
  },
  {
    code: "CH",
    name: "Cardiganshire"
  },
  {
    code: "CI",
    name: "Carmarthenshire"
  },
  {
    code: "CJ",
    name: "Central Bedfordshire"
  },
  {
    code: "CK",
    name: "Ceredigion"
  },
  {
    code: "CL",
    name: "Channel Islands"
  },
  {
    code: "CM",
    name: "Channel Isles"
  },
  {
    code: "CN",
    name: "Cheshire"
  },
  {
    code: "CO",
    name: "Cheshire East"
  },
  {
    code: "CP",
    name: "Cheshire West And Chester"
  },
  {
    code: "CQ",
    name: "City of Bristol"
  },
  {
    code: "CR",
    name: "City Of London"
  },
  {
    code: "CS",
    name: "Clackmannanshire"
  },
  {
    code: "CT",
    name: "Cleveland"
  },
  {
    code: "CU",
    name: "Clwyd"
  },
  {
    code: "CV",
    name: "Comhairle Nan Eilean Siar"
  },
  {
    code: "CW",
    name: "Conwy"
  },
  {
    code: "CX",
    name: "Cornwall"
  },
  {
    code: "CY",
    name: "Cornwall/Scilly"
  },
  {
    code: "CZ",
    name: "County Antrim"
  },
  {
    code: "C0",
    name: "County Armagh"
  },
  {
    code: "C1",
    name: "County Down"
  },
  {
    code: "C2",
    name: "County Durham"
  },
  {
    code: "C3",
    name: "County Fermanagh"
  },
  {
    code: "C4",
    name: "County Londonderry"
  },
  {
    code: "C5",
    name: "County Tyrone"
  },
  {
    code: "C6",
    name: "Coventry"
  },
  {
    code: "C7",
    name: "Croydon"
  },
  {
    code: "C8",
    name: "Cumberland"
  },
  {
    code: "C9",
    name: "Cumbria"
  },
  {
    code: "DA",
    name: "Darlington"
  },
  {
    code: "DB",
    name: "Denbighshire"
  },
  {
    code: "DC",
    name: "Derby"
  },
  {
    code: "DD",
    name: "Derbyshire"
  },
  {
    code: "DE",
    name: "Derry/Londonderry"
  },
  {
    code: "DF",
    name: "Devon"
  },
  {
    code: "DG",
    name: "Doncaster"
  },
  {
    code: "DH",
    name: "Dorset"
  },
  {
    code: "DI",
    name: "Down"
  },
  {
    code: "DJ",
    name: "Dudley"
  },
  {
    code: "DK",
    name: "Dumfries and Galloway"
  },
  {
    code: "DL",
    name: "Dumfriesshire"
  },
  {
    code: "DM",
    name: "Dunbartonshire"
  },
  {
    code: "DN",
    name: "Dundee"
  },
  {
    code: "DO",
    name: "Dundee City"
  },
  {
    code: "DP",
    name: "Durham"
  },
  {
    code: "DQ",
    name: "Dyfed"
  },
  {
    code: "EA",
    name: "Ealing"
  },
  {
    code: "EB",
    name: "East Ayrshire"
  },
  {
    code: "EC",
    name: "East Dunbartonshire"
  },
  {
    code: "ED",
    name: "East Lothian"
  },
  {
    code: "EE",
    name: "East Renfrewshire"
  },
  {
    code: "EF",
    name: "East Riding Of Yorkshire"
  },
  {
    code: "EG",
    name: "East Riding Yorkshire"
  },
  {
    code: "EH",
    name: "East Sussex"
  },
  {
    code: "EI",
    name: "Edinburgh"
  },
  {
    code: "EJ",
    name: "Edinburgh, City Of"
  },
  {
    code: "EK",
    name: "Eilean Siar"
  },
  {
    code: "EL",
    name: "Enfield"
  },
  {
    code: "EM",
    name: "England"
  },
  {
    code: "EN",
    name: "Essex"
  },
  {
    code: "FA",
    name: "Falkirk"
  },
  {
    code: "FB",
    name: "Fermanagh"
  },
  {
    code: "FC",
    name: "Fife"
  },
  {
    code: "FD",
    name: "Flintshire"
  },
  {
    code: "GA",
    name: "Gateshead"
  },
  {
    code: "GB",
    name: "Glamorgan"
  },
  {
    code: "GC",
    name: "Glasgow"
  },
  {
    code: "GD",
    name: "Glasgow City"
  },
  {
    code: "GE",
    name: "Gloucestershire"
  },
  {
    code: "GF",
    name: "Greater London"
  },
  {
    code: "GG",
    name: "Greater Manchester"
  },
  {
    code: "GH",
    name: "Greenwich"
  },
  {
    code: "GI",
    name: "Gwent"
  },
  {
    code: "GJ",
    name: "Gwynedd"
  },
  {
    code: "HA",
    name: "Hackney"
  },
  {
    code: "HB",
    name: "Halton"
  },
  {
    code: "HC",
    name: "Hammersmith And Fulham"
  },
  {
    code: "HD",
    name: "Hampshire"
  },
  {
    code: "HE",
    name: "Haringey"
  },
  {
    code: "HF",
    name: "Harrow"
  },
  {
    code: "HG",
    name: "Hartlepool"
  },
  {
    code: "HH",
    name: "Havering"
  },
  {
    code: "HI",
    name: "Herefordshire"
  },
  {
    code: "HJ",
    name: "Herefordshire, County Of"
  },
  {
    code: "HK",
    name: "Hertfordshire"
  },
  {
    code: "HL",
    name: "Highland"
  },
  {
    code: "HM",
    name: "Highlands"
  },
  {
    code: "HN",
    name: "Hillingdon"
  },
  {
    code: "HO",
    name: "Hounslow"
  },
  {
    code: "HP",
    name: "Huntingdonshire"
  },
  {
    code: "IA",
    name: "Inverclyde"
  },
  {
    code: "IB",
    name: "Inverness-Shire"
  },
  {
    code: "IC",
    name: "Isle Of Anglesey"
  },
  {
    code: '"ID"',
    name: "Isle Of Lewis"
  },
  {
    code: "IE",
    name: "Isle of Man"
  },
  {
    code: "IF",
    name: "Isle Of Wight"
  },
  {
    code: "IG",
    name: "Isles of Scilly"
  },
  {
    code: "IH",
    name: "Islington"
  },
  {
    code: "KA",
    name: "Kensington And Chelsea"
  },
  {
    code: "KB",
    name: "Kent"
  },
  {
    code: "KC",
    name: "Kincardineshire"
  },
  {
    code: "KD",
    name: "Kincardinshire"
  },
  {
    code: "KE",
    name: "Kingston Upon Hull"
  },
  {
    code: "KF",
    name: "Kingston Upon Hull, City Of"
  },
  {
    code: "KG",
    name: "Kingston Upon Thames"
  },
  {
    code: "KH",
    name: "Kinross-Shire"
  },
  {
    code: "KI",
    name: "Kirklees"
  },
  {
    code: "KJ",
    name: "Knowsley"
  },
  {
    code: "LA",
    name: "Lambeth"
  },
  {
    code: "LB",
    name: "Lanarkshire"
  },
  {
    code: "LC",
    name: "Lancashire"
  },
  {
    code: "LD",
    name: "Leeds"
  },
  {
    code: "LE",
    name: "Leicester"
  },
  {
    code: "LF",
    name: "Leicestershire"
  },
  {
    code: "LG",
    name: "Lewisham"
  },
  {
    code: "LH",
    name: "Lincolnshire"
  },
  {
    code: "LI",
    name: "Liverpool"
  },
  {
    code: "LJ",
    name: "Londonderry"
  },
  {
    code: "LK",
    name: "Luton"
  },
  {
    code: "MA",
    name: "Manchester"
  },
  {
    code: "MB",
    name: "Medway"
  },
  {
    code: "MC",
    name: "Merseyside"
  },
  {
    code: "MD",
    name: "Merthyr Tydfil"
  },
  {
    code: "ME",
    name: "Merton"
  },
  {
    code: "MF",
    name: "Mid Glamorgan"
  },
  {
    code: "MG",
    name: "Mid Lothian"
  },
  {
    code: "MH",
    name: "Middlesbrough"
  },
  {
    code: "MI",
    name: "Middlesex"
  },
  {
    code: "MJ",
    name: "Midlothian"
  },
  {
    code: "MK",
    name: "Milton Keynes"
  },
  {
    code: "ML",
    name: "Monmouthshire"
  },
  {
    code: "MM",
    name: "Moray"
  },
  {
    code: "MN",
    name: "Morayshire"
  },
  {
    code: "NA",
    name: "Neath & Port Talbot"
  },
  {
    code: "NB",
    name: "Neath Port Talbot"
  },
  {
    code: "NC",
    name: "Newcastle Upon Tyne"
  },
  {
    code: "ND",
    name: "Newham"
  },
  {
    code: "NE",
    name: "Newport"
  },
  {
    code: "NF",
    name: "Norfolk"
  },
  {
    code: "NG",
    name: "North Ayrshire"
  },
  {
    code: "NH",
    name: "North East Lincolnshire"
  },
  {
    code: "NI",
    name: "North Lanarkshire"
  },
  {
    code: "NJ",
    name: "North Lincolnshire"
  },
  {
    code: "NK",
    name: "North Somerset"
  },
  {
    code: "NL",
    name: "North Tyneside"
  },
  {
    code: "NM",
    name: "North Yorkshire"
  },
  {
    code: "NN",
    name: "Northamptonshire"
  },
  {
    code: "NO",
    name: "Northern Ireland"
  },
  {
    code: "NP",
    name: "Northumberland"
  },
  {
    code: "NQ",
    name: "Nottingham"
  },
  {
    code: "NR",
    name: "Nottinghamshire"
  },
  {
    code: "OA",
    name: "Oldham"
  },
  {
    code: "OB",
    name: "Orkney"
  },
  {
    code: "OC",
    name: "Orkney and Shetland Isles"
  },
  {
    code: "OD",
    name: "Orkney Islands"
  },
  {
    code: "OE",
    name: "Oxfordshire"
  },
  {
    code: "PA",
    name: "Pembrokeshire"
  },
  {
    code: "PB",
    name: "Perth & Kinross"
  },
  {
    code: "PC",
    name: "Perth and Kinross"
  },
  {
    code: "PD",
    name: "Perthshire"
  },
  {
    code: "PE",
    name: "Peterborough"
  },
  {
    code: "PF",
    name: "Plymouth"
  },
  {
    code: "PG",
    name: "Poole"
  },
  {
    code: "PH",
    name: "Portsmouth"
  },
  {
    code: "PI",
    name: "Powys"
  },
  {
    code: "PJ",
    name: "Preferred"
  },
  {
    code: "RA",
    name: "Reading"
  },
  {
    code: "RB",
    name: "Redbridge"
  },
  {
    code: "RC",
    name: "Redcar And Cleveland"
  },
  {
    code: "RD",
    name: "Renfrewshire"
  },
  {
    code: "RE",
    name: "Rhonda Cynon Taff"
  },
  {
    code: "RF",
    name: "Rhondda Cynon Taf"
  },
  {
    code: "RG",
    name: "Richmond Upon Thames"
  },
  {
    code: "RH",
    name: "Rochdale"
  },
  {
    code: "RI",
    name: "Ross-Shire"
  },
  {
    code: "RJ",
    name: "Rotherham"
  },
  {
    code: "RK",
    name: "Roxburghshire"
  },
  {
    code: "RL",
    name: "Rutland"
  },
  {
    code: "SA",
    name: "Salford"
  },
  {
    code: "SB",
    name: "Sandwell"
  },
  {
    code: "SC",
    name: "Scottish Borders"
  },
  {
    code: "SD",
    name: "Sefton"
  },
  {
    code: "SE",
    name: "Sheffield"
  },
  {
    code: "SF",
    name: "Shetland"
  },
  {
    code: "SG",
    name: "Shetland Islands"
  },
  {
    code: "SH",
    name: "Shropshire"
  },
  {
    code: "SI",
    name: "Slough"
  },
  {
    code: "SJ",
    name: "Solihull"
  },
  {
    code: "SK",
    name: "Somerset"
  },
  {
    code: "SL",
    name: "South Ayrshire"
  },
  {
    code: "SM",
    name: "South Glamorgan"
  },
  {
    code: "SN",
    name: "South Gloucestershire"
  },
  {
    code: "SO",
    name: "South Gloucesteshire"
  },
  {
    code: "SP",
    name: "South Lanarkshire"
  },
  {
    code: "SQ",
    name: "South Tyneside"
  },
  {
    code: "SR",
    name: "South Yorkshire"
  },
  {
    code: "SS",
    name: "Southampton"
  },
  {
    code: "ST",
    name: "Southend-On-Sea"
  },
  {
    code: "SU",
    name: "Southwark"
  },
  {
    code: "SV",
    name: "St. Helens"
  },
  {
    code: "SW",
    name: "Staffordshire"
  },
  {
    code: "SX",
    name: "Stirling"
  },
  {
    code: "SY",
    name: "Stirlingshire"
  },
  {
    code: "SZ",
    name: "Stockport"
  },
  {
    code: "S0",
    name: "Stockton On Tees"
  },
  {
    code: "S1",
    name: "Stockton-On-Tees"
  },
  {
    code: "S2",
    name: "Stoke-On-Trent"
  },
  {
    code: "S3",
    name: "Suffolk"
  },
  {
    code: "S4",
    name: "Sunderland"
  },
  {
    code: "S5",
    name: "Surrey"
  },
  {
    code: "S6",
    name: "Sussex"
  },
  {
    code: "S7",
    name: "Sutherland"
  },
  {
    code: "S8",
    name: "Sutton"
  },
  {
    code: "S9",
    name: "Swansea"
  },
  {
    code: "JA",
    name: "Swindon"
  },
  {
    code: "TA",
    name: "Tameside"
  },
  {
    code: "TB",
    name: "Telford And Wrekin"
  },
  {
    code: "TC",
    name: "Thurrock"
  },
  {
    code: "TD",
    name: "Torbay"
  },
  {
    code: "TE",
    name: "Torfaen"
  },
  {
    code: "TF",
    name: "Tower Hamlets"
  },
  {
    code: "TG",
    name: "Trafford"
  },
  {
    code: "TH",
    name: "Tyne And Wear"
  },
  {
    code: "TI",
    name: "Tyrone"
  },
  {
    code: "VA",
    name: "Vale Of Glamorgan"
  },
  {
    code: "WA",
    name: "Wakefield"
  },
  {
    code: "WB",
    name: "Wales"
  },
  {
    code: "WC",
    name: "Walsall"
  },
  {
    code: "WD",
    name: "Waltham Forest"
  },
  {
    code: "WE",
    name: "Wandsworth"
  },
  {
    code: "WF",
    name: "Warrington"
  },
  {
    code: "WG",
    name: "Warwickshire"
  },
  {
    code: "WH",
    name: "West Berkshire"
  },
  {
    code: "WI",
    name: "West Dunbartonshire"
  },
  {
    code: "WJ",
    name: "West Glamorgan"
  },
  {
    code: "WK",
    name: "West Lothian"
  },
  {
    code: "WL",
    name: "West Midlands"
  },
  {
    code: "WM",
    name: "West Sussex"
  },
  {
    code: "WN",
    name: "West Yorkshire"
  },
  {
    code: "WO",
    name: "Western Isles"
  },
  {
    code: "WP",
    name: "Westminster"
  },
  {
    code: "WQ",
    name: "Wigan"
  },
  {
    code: "WR",
    name: "Wiltshire"
  },
  {
    code: "WS",
    name: "Windsor And Maidenhead"
  },
  {
    code: "WT",
    name: "Wirral"
  },
  {
    code: "WU",
    name: "Wokingham"
  },
  {
    code: "WV",
    name: "Wolverhampton"
  },
  {
    code: "WW",
    name: "Worcestershire"
  },
  {
    code: "WX",
    name: "Wrexham"
  },
  {
    code: "YA",
    name: "York"
  },
  {
    code: "YB",
    name: "Yorkshire"
  }
];

const caStates: State[] = [
  {
    name: "Alberta",
    code: "AB"
  },
  {
    name: "British Columbia",
    code: "BC"
  },
  {
    name: "Manitoba",
    code: "MB"
  },
  {
    name: "New Brunswick",
    code: "NB"
  },
  {
    name: "Newfoundland / Labrador",
    code: "NL"
  },
  {
    name: "Northwest Territories",
    code: "NT"
  },
  {
    name: "Nova Scotia",
    code: "NS"
  },
  {
    name: "Nunavut",
    code: "NU"
  },
  {
    name: "Ontario",
    code: "ON"
  },
  {
    name: "Prince Edward Island",
    code: "PE"
  },
  {
    name: "Quebec",
    code: "QC"
  },
  {
    name: "Saskatchewan",
    code: "SK"
  },
  {
    name: "Yukon",
    code: "YT"
  }
];

const allAvailableStates = {
  US: usStates,
  CA: caStates,
  GB: gbStates
} as const;

export const getStateListByCountryCode = (
  countryCode: keyof typeof allAvailableStates
) => {
  return allAvailableStates[countryCode];
};

export type Country = {
  code: string;
  unicode?: string;
  name: string;
  emoji?: string;
  alpha3?: string;
};

export type Countries = {
  [key: string]: Country;
};

const countries: Countries = {
  AC: {
    code: "AC",
    unicode: "U+1F1E6 U+1F1E8",
    name: "Ascension Island",
    emoji: "🇦🇨"
  },
  AD: {
    code: "AD",
    unicode: "U+1F1E6 U+1F1E9",
    name: "Andorra",
    emoji: "🇦🇩",
    alpha3: "AND"
  },
  AE: {
    code: "AE",
    unicode: "U+1F1E6 U+1F1EA",
    name: "United Arab Emirates",
    emoji: "🇦🇪",
    alpha3: "ARE"
  },
  AF: {
    code: "AF",
    unicode: "U+1F1E6 U+1F1EB",
    name: "Afghanistan",
    emoji: "🇦🇫",
    alpha3: "AFG"
  },
  AG: {
    code: "AG",
    unicode: "U+1F1E6 U+1F1EC",
    name: "Antigua & Barbuda",
    emoji: "🇦🇬",
    alpha3: "ATG"
  },
  AI: {
    code: "AI",
    unicode: "U+1F1E6 U+1F1EE",
    name: "Anguilla",
    emoji: "🇦🇮",
    alpha3: "AIA"
  },
  AL: {
    code: "AL",
    unicode: "U+1F1E6 U+1F1F1",
    name: "Albania",
    emoji: "🇦🇱",
    alpha3: "ALB"
  },
  AM: {
    code: "AM",
    unicode: "U+1F1E6 U+1F1F2",
    name: "Armenia",
    emoji: "🇦🇲",
    alpha3: "ARM"
  },
  AO: {
    code: "AO",
    unicode: "U+1F1E6 U+1F1F4",
    name: "Angola",
    emoji: "🇦🇴",
    alpha3: "AGO"
  },
  AQ: {
    code: "AQ",
    unicode: "U+1F1E6 U+1F1F6",
    name: "Antarctica",
    emoji: "🇦🇶",
    alpha3: "ATA"
  },
  AR: {
    code: "AR",
    unicode: "U+1F1E6 U+1F1F7",
    name: "Argentina",
    emoji: "🇦🇷",
    alpha3: "ARG"
  },
  AS: {
    code: "AS",
    unicode: "U+1F1E6 U+1F1F8",
    name: "American Samoa",
    emoji: "🇦🇸",
    alpha3: "ASM"
  },
  AT: {
    code: "AT",
    unicode: "U+1F1E6 U+1F1F9",
    name: "Austria",
    emoji: "🇦🇹",
    alpha3: "AUT"
  },
  AU: {
    code: "AU",
    unicode: "U+1F1E6 U+1F1FA",
    name: "Australia",
    emoji: "🇦🇺",
    alpha3: "AUS"
  },
  AW: {
    code: "AW",
    unicode: "U+1F1E6 U+1F1FC",
    name: "Aruba",
    emoji: "🇦🇼",
    alpha3: "ABW"
  },
  AX: {
    code: "AX",
    unicode: "U+1F1E6 U+1F1FD",
    name: "Åland Islands",
    emoji: "🇦🇽",
    alpha3: "ALA"
  },
  AZ: {
    code: "AZ",
    unicode: "U+1F1E6 U+1F1FF",
    name: "Azerbaijan",
    emoji: "🇦🇿",
    alpha3: "AZE"
  },
  BA: {
    code: "BA",
    unicode: "U+1F1E7 U+1F1E6",
    name: "Bosnia & Herzegovina",
    emoji: "🇧🇦",
    alpha3: "BIH"
  },
  BB: {
    code: "BB",
    unicode: "U+1F1E7 U+1F1E7",
    name: "Barbados",
    emoji: "🇧🇧",
    alpha3: "BRB"
  },
  BD: {
    code: "BD",
    unicode: "U+1F1E7 U+1F1E9",
    name: "Bangladesh",
    emoji: "🇧🇩",
    alpha3: "BGD"
  },
  BE: {
    code: "BE",
    unicode: "U+1F1E7 U+1F1EA",
    name: "Belgium",
    emoji: "🇧🇪",
    alpha3: "BEL"
  },
  BF: {
    code: "BF",
    unicode: "U+1F1E7 U+1F1EB",
    name: "Burkina Faso",
    emoji: "🇧🇫",
    alpha3: "BFA"
  },
  BG: {
    code: "BG",
    unicode: "U+1F1E7 U+1F1EC",
    name: "Bulgaria",
    emoji: "🇧🇬",
    alpha3: "BGR"
  },
  BH: {
    code: "BH",
    unicode: "U+1F1E7 U+1F1ED",
    name: "Bahrain",
    emoji: "🇧🇭",
    alpha3: "BHR"
  },
  BI: {
    code: "BI",
    unicode: "U+1F1E7 U+1F1EE",
    name: "Burundi",
    emoji: "🇧🇮",
    alpha3: "BDI"
  },
  BJ: {
    code: "BJ",
    unicode: "U+1F1E7 U+1F1EF",
    name: "Benin",
    emoji: "🇧🇯",
    alpha3: "BEN"
  },
  BL: {
    code: "BL",
    unicode: "U+1F1E7 U+1F1F1",
    name: "St. Barthélemy",
    emoji: "🇧🇱",
    alpha3: "BLM"
  },
  BM: {
    code: "BM",
    unicode: "U+1F1E7 U+1F1F2",
    name: "Bermuda",
    emoji: "🇧🇲",
    alpha3: "BMU"
  },
  BN: {
    code: "BN",
    unicode: "U+1F1E7 U+1F1F3",
    name: "Brunei",
    emoji: "🇧🇳",
    alpha3: "BRN"
  },
  BO: {
    code: "BO",
    unicode: "U+1F1E7 U+1F1F4",
    name: "Bolivia",
    emoji: "🇧🇴",
    alpha3: "BOL"
  },
  BQ: {
    code: "BQ",
    unicode: "U+1F1E7 U+1F1F6",
    name: "Caribbean Netherlands",
    emoji: "🇧🇶",
    alpha3: "BES"
  },
  BR: {
    code: "BR",
    unicode: "U+1F1E7 U+1F1F7",
    name: "Brazil",
    emoji: "🇧🇷",
    alpha3: "BRA"
  },
  BS: {
    code: "BS",
    unicode: "U+1F1E7 U+1F1F8",
    name: "Bahamas",
    emoji: "🇧🇸",
    alpha3: "BHS"
  },
  BT: {
    code: "BT",
    unicode: "U+1F1E7 U+1F1F9",
    name: "Bhutan",
    emoji: "🇧🇹",
    alpha3: "BTN"
  },
  BV: {
    code: "BV",
    unicode: "U+1F1E7 U+1F1FB",
    name: "Bouvet Island",
    emoji: "🇧🇻",
    alpha3: "BVT"
  },
  BW: {
    code: "BW",
    unicode: "U+1F1E7 U+1F1FC",
    name: "Botswana",
    emoji: "🇧🇼",
    alpha3: "BWA"
  },
  BY: {
    code: "BY",
    unicode: "U+1F1E7 U+1F1FE",
    name: "Belarus",
    emoji: "🇧🇾",
    alpha3: "BLR"
  },
  BZ: {
    code: "BZ",
    unicode: "U+1F1E7 U+1F1FF",
    name: "Belize",
    emoji: "🇧🇿",
    alpha3: "BLZ"
  },
  CA: {
    code: "CA",
    unicode: "U+1F1E8 U+1F1E6",
    name: "Canada",
    emoji: "🇨🇦",
    alpha3: "CAN"
  },
  CC: {
    code: "CC",
    unicode: "U+1F1E8 U+1F1E8",
    name: "Cocos (Keeling) Islands",
    emoji: "🇨🇨",
    alpha3: "CCK"
  },
  CD: {
    code: "CD",
    unicode: "U+1F1E8 U+1F1E9",
    name: "Congo - Kinshasa",
    emoji: "🇨🇩",
    alpha3: "COD"
  },
  CF: {
    code: "CF",
    unicode: "U+1F1E8 U+1F1EB",
    name: "Central African Republic",
    emoji: "🇨🇫",
    alpha3: "CAF"
  },
  CG: {
    code: "CG",
    unicode: "U+1F1E8 U+1F1EC",
    name: "Congo - Brazzaville",
    emoji: "🇨🇬",
    alpha3: "COG"
  },
  CH: {
    code: "CH",
    unicode: "U+1F1E8 U+1F1ED",
    name: "Switzerland",
    emoji: "🇨🇭",
    alpha3: "CHE"
  },
  CI: {
    code: "CI",
    unicode: "U+1F1E8 U+1F1EE",
    name: "Côte d’Ivoire",
    emoji: "🇨🇮",
    alpha3: "CIV"
  },
  CK: {
    code: "CK",
    unicode: "U+1F1E8 U+1F1F0",
    name: "Cook Islands",
    emoji: "🇨🇰",
    alpha3: "COK"
  },
  CL: {
    code: "CL",
    unicode: "U+1F1E8 U+1F1F1",
    name: "Chile",
    emoji: "🇨🇱",
    alpha3: "CHL"
  },
  CM: {
    code: "CM",
    unicode: "U+1F1E8 U+1F1F2",
    name: "Cameroon",
    emoji: "🇨🇲",
    alpha3: "CMR"
  },
  CN: {
    code: "CN",
    unicode: "U+1F1E8 U+1F1F3",
    name: "China",
    emoji: "🇨🇳",
    alpha3: "CHN"
  },
  CO: {
    code: "CO",
    unicode: "U+1F1E8 U+1F1F4",
    name: "Colombia",
    emoji: "🇨🇴",
    alpha3: "COL"
  },
  CP: {
    code: "CP",
    unicode: "U+1F1E8 U+1F1F5",
    name: "Clipperton Island",
    emoji: "🇨🇵"
  },
  CR: {
    code: "CR",
    unicode: "U+1F1E8 U+1F1F7",
    name: "Costa Rica",
    emoji: "🇨🇷",
    alpha3: "CRI"
  },
  CU: {
    code: "CU",
    unicode: "U+1F1E8 U+1F1FA",
    name: "Cuba",
    emoji: "🇨🇺",
    alpha3: "CUB"
  },
  CV: {
    code: "CV",
    unicode: "U+1F1E8 U+1F1FB",
    name: "Cape Verde",
    emoji: "🇨🇻",
    alpha3: "CPV"
  },
  CW: {
    code: "CW",
    unicode: "U+1F1E8 U+1F1FC",
    name: "Curaçao",
    emoji: "🇨🇼",
    alpha3: "CUW"
  },
  CX: {
    code: "CX",
    unicode: "U+1F1E8 U+1F1FD",
    name: "Christmas Island",
    emoji: "🇨🇽",
    alpha3: "CXR"
  },
  CY: {
    code: "CY",
    unicode: "U+1F1E8 U+1F1FE",
    name: "Cyprus",
    emoji: "🇨🇾",
    alpha3: "CYP"
  },
  CZ: {
    code: "CZ",
    unicode: "U+1F1E8 U+1F1FF",
    name: "Czechia",
    emoji: "🇨🇿",
    alpha3: "CZE"
  },
  DE: {
    code: "DE",
    unicode: "U+1F1E9 U+1F1EA",
    name: "Germany",
    emoji: "🇩🇪",
    alpha3: "DEU"
  },
  DG: {
    code: "DG",
    unicode: "U+1F1E9 U+1F1EC",
    name: "Diego Garcia",
    emoji: "🇩🇬"
  },
  DJ: {
    code: "DJ",
    unicode: "U+1F1E9 U+1F1EF",
    name: "Djibouti",
    emoji: "🇩🇯",
    alpha3: "DJI"
  },
  DK: {
    code: "DK",
    unicode: "U+1F1E9 U+1F1F0",
    name: "Denmark",
    emoji: "🇩🇰",
    alpha3: "DNK"
  },
  DM: {
    code: "DM",
    unicode: "U+1F1E9 U+1F1F2",
    name: "Dominica",
    emoji: "🇩🇲",
    alpha3: "DMA"
  },
  DO: {
    code: "DO",
    unicode: "U+1F1E9 U+1F1F4",
    name: "Dominican Republic",
    emoji: "🇩🇴",
    alpha3: "DOM"
  },
  DZ: {
    code: "DZ",
    unicode: "U+1F1E9 U+1F1FF",
    name: "Algeria",
    emoji: "🇩🇿",
    alpha3: "DZA"
  },
  EA: {
    code: "EA",
    unicode: "U+1F1EA U+1F1E6",
    name: "Ceuta & Melilla",
    emoji: "🇪🇦"
  },
  EC: {
    code: "EC",
    unicode: "U+1F1EA U+1F1E8",
    name: "Ecuador",
    emoji: "🇪🇨",
    alpha3: "ECU"
  },
  EE: {
    code: "EE",
    unicode: "U+1F1EA U+1F1EA",
    name: "Estonia",
    emoji: "🇪🇪",
    alpha3: "EST"
  },
  EG: {
    code: "EG",
    unicode: "U+1F1EA U+1F1EC",
    name: "Egypt",
    emoji: "🇪🇬",
    alpha3: "EGY"
  },
  EH: {
    code: "EH",
    unicode: "U+1F1EA U+1F1ED",
    name: "Western Sahara",
    emoji: "🇪🇭",
    alpha3: "ESH"
  },
  ER: {
    code: "ER",
    unicode: "U+1F1EA U+1F1F7",
    name: "Eritrea",
    emoji: "🇪🇷",
    alpha3: "ERI"
  },
  ES: {
    code: "ES",
    unicode: "U+1F1EA U+1F1F8",
    name: "Spain",
    emoji: "🇪🇸",
    alpha3: "ESP"
  },
  ET: {
    code: "ET",
    unicode: "U+1F1EA U+1F1F9",
    name: "Ethiopia",
    emoji: "🇪🇹",
    alpha3: "ETH"
  },
  EU: {
    code: "EU",
    unicode: "U+1F1EA U+1F1FA",
    name: "European Union",
    emoji: "🇪🇺"
  },
  FI: {
    code: "FI",
    unicode: "U+1F1EB U+1F1EE",
    name: "Finland",
    emoji: "🇫🇮",
    alpha3: "FIN"
  },
  FJ: {
    code: "FJ",
    unicode: "U+1F1EB U+1F1EF",
    name: "Fiji",
    emoji: "🇫🇯",
    alpha3: "FJI"
  },
  FK: {
    code: "FK",
    unicode: "U+1F1EB U+1F1F0",
    name: "Falkland Islands",
    emoji: "🇫🇰",
    alpha3: "FLK"
  },
  FM: {
    code: "FM",
    unicode: "U+1F1EB U+1F1F2",
    name: "Micronesia",
    emoji: "🇫🇲",
    alpha3: "FSM"
  },
  FO: {
    code: "FO",
    unicode: "U+1F1EB U+1F1F4",
    name: "Faroe Islands",
    emoji: "🇫🇴",
    alpha3: "FRO"
  },
  FR: {
    code: "FR",
    unicode: "U+1F1EB U+1F1F7",
    name: "France",
    emoji: "🇫🇷",
    alpha3: "FRA"
  },
  GA: {
    code: "GA",
    unicode: "U+1F1EC U+1F1E6",
    name: "Gabon",
    emoji: "🇬🇦",
    alpha3: "GAB"
  },
  GB: {
    code: "GB",
    unicode: "U+1F1EC U+1F1E7",
    name: "United Kingdom",
    emoji: "🇬🇧",
    alpha3: "GBR"
  },
  GD: {
    code: "GD",
    unicode: "U+1F1EC U+1F1E9",
    name: "Grenada",
    emoji: "🇬🇩",
    alpha3: "GRD"
  },
  GE: {
    code: "GE",
    unicode: "U+1F1EC U+1F1EA",
    name: "Georgia",
    emoji: "🇬🇪",
    alpha3: "GEO"
  },
  GF: {
    code: "GF",
    unicode: "U+1F1EC U+1F1EB",
    name: "French Guiana",
    emoji: "🇬🇫",
    alpha3: "GUF"
  },
  GG: {
    code: "GG",
    unicode: "U+1F1EC U+1F1EC",
    name: "Guernsey",
    emoji: "🇬🇬",
    alpha3: "GGY"
  },
  GH: {
    code: "GH",
    unicode: "U+1F1EC U+1F1ED",
    name: "Ghana",
    emoji: "🇬🇭",
    alpha3: "GHA"
  },
  GI: {
    code: "GI",
    unicode: "U+1F1EC U+1F1EE",
    name: "Gibraltar",
    emoji: "🇬🇮",
    alpha3: "GIB"
  },
  GL: {
    code: "GL",
    unicode: "U+1F1EC U+1F1F1",
    name: "Greenland",
    emoji: "🇬🇱",
    alpha3: "GRL"
  },
  GM: {
    code: "GM",
    unicode: "U+1F1EC U+1F1F2",
    name: "Gambia",
    emoji: "🇬🇲",
    alpha3: "GMB"
  },
  GN: {
    code: "GN",
    unicode: "U+1F1EC U+1F1F3",
    name: "Guinea",
    emoji: "🇬🇳",
    alpha3: "GIN"
  },
  GP: {
    code: "GP",
    unicode: "U+1F1EC U+1F1F5",
    name: "Guadeloupe",
    emoji: "🇬🇵",
    alpha3: "GLP"
  },
  GQ: {
    code: "GQ",
    unicode: "U+1F1EC U+1F1F6",
    name: "Equatorial Guinea",
    emoji: "🇬🇶",
    alpha3: "GNQ"
  },
  GR: {
    code: "GR",
    unicode: "U+1F1EC U+1F1F7",
    name: "Greece",
    emoji: "🇬🇷",
    alpha3: "GRC"
  },
  GS: {
    code: "GS",
    unicode: "U+1F1EC U+1F1F8",
    name: "South Georgia & South Sandwich Islands",
    emoji: "🇬🇸",
    alpha3: "SGS"
  },
  GT: {
    code: "GT",
    unicode: "U+1F1EC U+1F1F9",
    name: "Guatemala",
    emoji: "🇬🇹",
    alpha3: "GTM"
  },
  GU: {
    code: "GU",
    unicode: "U+1F1EC U+1F1FA",
    name: "Guam",
    emoji: "🇬🇺",
    alpha3: "GUM"
  },
  GW: {
    code: "GW",
    unicode: "U+1F1EC U+1F1FC",
    name: "Guinea-Bissau",
    emoji: "🇬🇼",
    alpha3: "GNB"
  },
  GY: {
    code: "GY",
    unicode: "U+1F1EC U+1F1FE",
    name: "Guyana",
    emoji: "🇬🇾",
    alpha3: "GUY"
  },
  HK: {
    code: "HK",
    unicode: "U+1F1ED U+1F1F0",
    name: "Hong Kong SAR China",
    emoji: "🇭🇰",
    alpha3: "HKG"
  },
  HM: {
    code: "HM",
    unicode: "U+1F1ED U+1F1F2",
    name: "Heard & McDonald Islands",
    emoji: "🇭🇲",
    alpha3: "HMD"
  },
  HN: {
    code: "HN",
    unicode: "U+1F1ED U+1F1F3",
    name: "Honduras",
    emoji: "🇭🇳",
    alpha3: "HND"
  },
  HR: {
    code: "HR",
    unicode: "U+1F1ED U+1F1F7",
    name: "Croatia",
    emoji: "🇭🇷",
    alpha3: "HRV"
  },
  HT: {
    code: "HT",
    unicode: "U+1F1ED U+1F1F9",
    name: "Haiti",
    emoji: "🇭🇹",
    alpha3: "HTI"
  },
  HU: {
    code: "HU",
    unicode: "U+1F1ED U+1F1FA",
    name: "Hungary",
    emoji: "🇭🇺",
    alpha3: "HUN"
  },
  IC: {
    code: "IC",
    unicode: "U+1F1EE U+1F1E8",
    name: "Canary Islands",
    emoji: "🇮🇨"
  },
  ID: {
    code: "ID",
    unicode: "U+1F1EE U+1F1E9",
    name: "Indonesia",
    emoji: "🇮🇩",
    alpha3: "IDN"
  },
  IE: {
    code: "IE",
    unicode: "U+1F1EE U+1F1EA",
    name: "Ireland",
    emoji: "🇮🇪",
    alpha3: "IRL"
  },
  IL: {
    code: "IL",
    unicode: "U+1F1EE U+1F1F1",
    name: "Israel",
    emoji: "🇮🇱",
    alpha3: "ISR"
  },
  IM: {
    code: "IM",
    unicode: "U+1F1EE U+1F1F2",
    name: "Isle of Man",
    emoji: "🇮🇲",
    alpha3: "IMN"
  },
  IN: {
    code: "IN",
    unicode: "U+1F1EE U+1F1F3",
    name: "India",
    emoji: "🇮🇳",
    alpha3: "IND"
  },
  IO: {
    code: "IO",
    unicode: "U+1F1EE U+1F1F4",
    name: "British Indian Ocean Territory",
    emoji: "🇮🇴",
    alpha3: "IOT"
  },
  IQ: {
    code: "IQ",
    unicode: "U+1F1EE U+1F1F6",
    name: "Iraq",
    emoji: "🇮🇶",
    alpha3: "IRQ"
  },
  IR: {
    code: "IR",
    unicode: "U+1F1EE U+1F1F7",
    name: "Iran",
    emoji: "🇮🇷",
    alpha3: "IRN"
  },
  IS: {
    code: "IS",
    unicode: "U+1F1EE U+1F1F8",
    name: "Iceland",
    emoji: "🇮🇸",
    alpha3: "ISL"
  },
  IT: {
    code: "IT",
    unicode: "U+1F1EE U+1F1F9",
    name: "Italy",
    emoji: "🇮🇹",
    alpha3: "ITA"
  },
  JE: {
    code: "JE",
    unicode: "U+1F1EF U+1F1EA",
    name: "Jersey",
    emoji: "🇯🇪",
    alpha3: "JEY"
  },
  JM: {
    code: "JM",
    unicode: "U+1F1EF U+1F1F2",
    name: "Jamaica",
    emoji: "🇯🇲",
    alpha3: "JAM"
  },
  JO: {
    code: "JO",
    unicode: "U+1F1EF U+1F1F4",
    name: "Jordan",
    emoji: "🇯🇴",
    alpha3: "JOR"
  },
  JP: {
    code: "JP",
    unicode: "U+1F1EF U+1F1F5",
    name: "Japan",
    emoji: "🇯🇵",
    alpha3: "JPN"
  },
  KE: {
    code: "KE",
    unicode: "U+1F1F0 U+1F1EA",
    name: "Kenya",
    emoji: "🇰🇪",
    alpha3: "KEN"
  },
  KG: {
    code: "KG",
    unicode: "U+1F1F0 U+1F1EC",
    name: "Kyrgyzstan",
    emoji: "🇰🇬",
    alpha3: "KGZ"
  },
  KH: {
    code: "KH",
    unicode: "U+1F1F0 U+1F1ED",
    name: "Cambodia",
    emoji: "🇰🇭",
    alpha3: "KHM"
  },
  KI: {
    code: "KI",
    unicode: "U+1F1F0 U+1F1EE",
    name: "Kiribati",
    emoji: "🇰🇮",
    alpha3: "KIR"
  },
  KM: {
    code: "KM",
    unicode: "U+1F1F0 U+1F1F2",
    name: "Comoros",
    emoji: "🇰🇲",
    alpha3: "COM"
  },
  KN: {
    code: "KN",
    unicode: "U+1F1F0 U+1F1F3",
    name: "St. Kitts & Nevis",
    emoji: "🇰🇳",
    alpha3: "KNA"
  },
  KP: {
    code: "KP",
    unicode: "U+1F1F0 U+1F1F5",
    name: "North Korea",
    emoji: "🇰🇵",
    alpha3: "PRK"
  },
  KR: {
    code: "KR",
    unicode: "U+1F1F0 U+1F1F7",
    name: "South Korea",
    emoji: "🇰🇷",
    alpha3: "KOR"
  },
  KW: {
    code: "KW",
    unicode: "U+1F1F0 U+1F1FC",
    name: "Kuwait",
    emoji: "🇰🇼",
    alpha3: "KWT"
  },
  KY: {
    code: "KY",
    unicode: "U+1F1F0 U+1F1FE",
    name: "Cayman Islands",
    emoji: "🇰🇾",
    alpha3: "CYM"
  },
  KZ: {
    code: "KZ",
    unicode: "U+1F1F0 U+1F1FF",
    name: "Kazakhstan",
    emoji: "🇰🇿",
    alpha3: "KAZ"
  },
  LA: {
    code: "LA",
    unicode: "U+1F1F1 U+1F1E6",
    name: "Laos",
    emoji: "🇱🇦",
    alpha3: "LAO"
  },
  LB: {
    code: "LB",
    unicode: "U+1F1F1 U+1F1E7",
    name: "Lebanon",
    emoji: "🇱🇧",
    alpha3: "LBN"
  },
  LC: {
    code: "LC",
    unicode: "U+1F1F1 U+1F1E8",
    name: "St. Lucia",
    emoji: "🇱🇨",
    alpha3: "LCA"
  },
  LI: {
    code: "LI",
    unicode: "U+1F1F1 U+1F1EE",
    name: "Liechtenstein",
    emoji: "🇱🇮",
    alpha3: "LIE"
  },
  LK: {
    code: "LK",
    unicode: "U+1F1F1 U+1F1F0",
    name: "Sri Lanka",
    emoji: "🇱🇰",
    alpha3: "LKA"
  },
  LR: {
    code: "LR",
    unicode: "U+1F1F1 U+1F1F7",
    name: "Liberia",
    emoji: "🇱🇷",
    alpha3: "LBR"
  },
  LS: {
    code: "LS",
    unicode: "U+1F1F1 U+1F1F8",
    name: "Lesotho",
    emoji: "🇱🇸",
    alpha3: "LSO"
  },
  LT: {
    code: "LT",
    unicode: "U+1F1F1 U+1F1F9",
    name: "Lithuania",
    emoji: "🇱🇹",
    alpha3: "LTU"
  },
  LU: {
    code: "LU",
    unicode: "U+1F1F1 U+1F1FA",
    name: "Luxembourg",
    emoji: "🇱🇺",
    alpha3: "LUX"
  },
  LV: {
    code: "LV",
    unicode: "U+1F1F1 U+1F1FB",
    name: "Latvia",
    emoji: "🇱🇻",
    alpha3: "LVA"
  },
  LY: {
    code: "LY",
    unicode: "U+1F1F1 U+1F1FE",
    name: "Libya",
    emoji: "🇱🇾",
    alpha3: "LBY"
  },
  MA: {
    code: "MA",
    unicode: "U+1F1F2 U+1F1E6",
    name: "Morocco",
    emoji: "🇲🇦",
    alpha3: "MAR"
  },
  MC: {
    code: "MC",
    unicode: "U+1F1F2 U+1F1E8",
    name: "Monaco",
    emoji: "🇲🇨",
    alpha3: "MCO"
  },
  MD: {
    code: "MD",
    unicode: "U+1F1F2 U+1F1E9",
    name: "Moldova",
    emoji: "🇲🇩",
    alpha3: "MDA"
  },
  ME: {
    code: "ME",
    unicode: "U+1F1F2 U+1F1EA",
    name: "Montenegro",
    emoji: "🇲🇪",
    alpha3: "MNE"
  },
  MF: {
    code: "MF",
    unicode: "U+1F1F2 U+1F1EB",
    name: "St. Martin",
    emoji: "🇲🇫",
    alpha3: "MAF"
  },
  MG: {
    code: "MG",
    unicode: "U+1F1F2 U+1F1EC",
    name: "Madagascar",
    emoji: "🇲🇬",
    alpha3: "MDG"
  },
  MH: {
    code: "MH",
    unicode: "U+1F1F2 U+1F1ED",
    name: "Marshall Islands",
    emoji: "🇲🇭",
    alpha3: "MHL"
  },
  MK: {
    code: "MK",
    unicode: "U+1F1F2 U+1F1F0",
    name: "Macedonia",
    emoji: "🇲🇰",
    alpha3: "MKD"
  },
  ML: {
    code: "ML",
    unicode: "U+1F1F2 U+1F1F1",
    name: "Mali",
    emoji: "🇲🇱",
    alpha3: "MLI"
  },
  MM: {
    code: "MM",
    unicode: "U+1F1F2 U+1F1F2",
    name: "Myanmar (Burma)",
    emoji: "🇲🇲",
    alpha3: "MMR"
  },
  MN: {
    code: "MN",
    unicode: "U+1F1F2 U+1F1F3",
    name: "Mongolia",
    emoji: "🇲🇳",
    alpha3: "MNG"
  },
  MO: {
    code: "MO",
    unicode: "U+1F1F2 U+1F1F4",
    name: "Macau SAR China",
    emoji: "🇲🇴",
    alpha3: "MAC"
  },
  MP: {
    code: "MP",
    unicode: "U+1F1F2 U+1F1F5",
    name: "Northern Mariana Islands",
    emoji: "🇲🇵",
    alpha3: "MNP"
  },
  MQ: {
    code: "MQ",
    unicode: "U+1F1F2 U+1F1F6",
    name: "Martinique",
    emoji: "🇲🇶",
    alpha3: "MTQ"
  },
  MR: {
    code: "MR",
    unicode: "U+1F1F2 U+1F1F7",
    name: "Mauritania",
    emoji: "🇲🇷",
    alpha3: "MRT"
  },
  MS: {
    code: "MS",
    unicode: "U+1F1F2 U+1F1F8",
    name: "Montserrat",
    emoji: "🇲🇸",
    alpha3: "MSR"
  },
  MT: {
    code: "MT",
    unicode: "U+1F1F2 U+1F1F9",
    name: "Malta",
    emoji: "🇲🇹",
    alpha3: "MLT"
  },
  MU: {
    code: "MU",
    unicode: "U+1F1F2 U+1F1FA",
    name: "Mauritius",
    emoji: "🇲🇺",
    alpha3: "MUS"
  },
  MV: {
    code: "MV",
    unicode: "U+1F1F2 U+1F1FB",
    name: "Maldives",
    emoji: "🇲🇻",
    alpha3: "MDV"
  },
  MW: {
    code: "MW",
    unicode: "U+1F1F2 U+1F1FC",
    name: "Malawi",
    emoji: "🇲🇼",
    alpha3: "MWI"
  },
  MX: {
    code: "MX",
    unicode: "U+1F1F2 U+1F1FD",
    name: "Mexico",
    emoji: "🇲🇽",
    alpha3: "MEX"
  },
  MY: {
    code: "MY",
    unicode: "U+1F1F2 U+1F1FE",
    name: "Malaysia",
    emoji: "🇲🇾",
    alpha3: "MYS"
  },
  MZ: {
    code: "MZ",
    unicode: "U+1F1F2 U+1F1FF",
    name: "Mozambique",
    emoji: "🇲🇿",
    alpha3: "MOZ"
  },
  NA: {
    code: "NA",
    unicode: "U+1F1F3 U+1F1E6",
    name: "Namibia",
    emoji: "🇳🇦",
    alpha3: "NAM"
  },
  NC: {
    code: "NC",
    unicode: "U+1F1F3 U+1F1E8",
    name: "New Caledonia",
    emoji: "🇳🇨",
    alpha3: "NCL"
  },
  NE: {
    code: "NE",
    unicode: "U+1F1F3 U+1F1EA",
    name: "Niger",
    emoji: "🇳🇪",
    alpha3: "NER"
  },
  NF: {
    code: "NF",
    unicode: "U+1F1F3 U+1F1EB",
    name: "Norfolk Island",
    emoji: "🇳🇫",
    alpha3: "NFK"
  },
  NG: {
    code: "NG",
    unicode: "U+1F1F3 U+1F1EC",
    name: "Nigeria",
    emoji: "🇳🇬",
    alpha3: "NGA"
  },
  NI: {
    code: "NI",
    unicode: "U+1F1F3 U+1F1EE",
    name: "Nicaragua",
    emoji: "🇳🇮",
    alpha3: "NIC"
  },
  NL: {
    code: "NL",
    unicode: "U+1F1F3 U+1F1F1",
    name: "Netherlands",
    emoji: "🇳🇱",
    alpha3: "NLD"
  },
  NO: {
    code: "NO",
    unicode: "U+1F1F3 U+1F1F4",
    name: "Norway",
    emoji: "🇳🇴",
    alpha3: "NOR"
  },
  NP: {
    code: "NP",
    unicode: "U+1F1F3 U+1F1F5",
    name: "Nepal",
    emoji: "🇳🇵",
    alpha3: "NPL"
  },
  NR: {
    code: "NR",
    unicode: "U+1F1F3 U+1F1F7",
    name: "Nauru",
    emoji: "🇳🇷",
    alpha3: "NRU"
  },
  NU: {
    code: "NU",
    unicode: "U+1F1F3 U+1F1FA",
    name: "Niue",
    emoji: "🇳🇺",
    alpha3: "NIU"
  },
  NZ: {
    code: "NZ",
    unicode: "U+1F1F3 U+1F1FF",
    name: "New Zealand",
    emoji: "🇳🇿",
    alpha3: "NZL"
  },
  OM: {
    code: "OM",
    unicode: "U+1F1F4 U+1F1F2",
    name: "Oman",
    emoji: "🇴🇲",
    alpha3: "OMN"
  },
  PA: {
    code: "PA",
    unicode: "U+1F1F5 U+1F1E6",
    name: "Panama",
    emoji: "🇵🇦",
    alpha3: "PAN"
  },
  PE: {
    code: "PE",
    unicode: "U+1F1F5 U+1F1EA",
    name: "Peru",
    emoji: "🇵🇪",
    alpha3: "PER"
  },
  PF: {
    code: "PF",
    unicode: "U+1F1F5 U+1F1EB",
    name: "French Polynesia",
    emoji: "🇵🇫",
    alpha3: "PYF"
  },
  PG: {
    code: "PG",
    unicode: "U+1F1F5 U+1F1EC",
    name: "Papua New Guinea",
    emoji: "🇵🇬",
    alpha3: "PNG"
  },
  PH: {
    code: "PH",
    unicode: "U+1F1F5 U+1F1ED",
    name: "Philippines",
    emoji: "🇵🇭",
    alpha3: "PHL"
  },
  PK: {
    code: "PK",
    unicode: "U+1F1F5 U+1F1F0",
    name: "Pakistan",
    emoji: "🇵🇰",
    alpha3: "PAK"
  },
  PL: {
    code: "PL",
    unicode: "U+1F1F5 U+1F1F1",
    name: "Poland",
    emoji: "🇵🇱",
    alpha3: "POL"
  },
  PM: {
    code: "PM",
    unicode: "U+1F1F5 U+1F1F2",
    name: "St. Pierre & Miquelon",
    emoji: "🇵🇲",
    alpha3: "SPM"
  },
  PN: {
    code: "PN",
    unicode: "U+1F1F5 U+1F1F3",
    name: "Pitcairn Islands",
    emoji: "🇵🇳",
    alpha3: "PCN"
  },
  PR: {
    code: "PR",
    unicode: "U+1F1F5 U+1F1F7",
    name: "Puerto Rico",
    emoji: "🇵🇷",
    alpha3: "PRI"
  },
  PS: {
    code: "PS",
    unicode: "U+1F1F5 U+1F1F8",
    name: "Palestinian Territories",
    emoji: "🇵🇸",
    alpha3: "PSE"
  },
  PT: {
    code: "PT",
    unicode: "U+1F1F5 U+1F1F9",
    name: "Portugal",
    emoji: "🇵🇹",
    alpha3: "PRT"
  },
  PW: {
    code: "PW",
    unicode: "U+1F1F5 U+1F1FC",
    name: "Palau",
    emoji: "🇵🇼",
    alpha3: "PLW"
  },
  PY: {
    code: "PY",
    unicode: "U+1F1F5 U+1F1FE",
    name: "Paraguay",
    emoji: "🇵🇾",
    alpha3: "PRY"
  },
  QA: {
    code: "QA",
    unicode: "U+1F1F6 U+1F1E6",
    name: "Qatar",
    emoji: "🇶🇦",
    alpha3: "QAT"
  },
  RE: {
    code: "RE",
    unicode: "U+1F1F7 U+1F1EA",
    name: "Réunion",
    emoji: "🇷🇪",
    alpha3: "REU"
  },
  RO: {
    code: "RO",
    unicode: "U+1F1F7 U+1F1F4",
    name: "Romania",
    emoji: "🇷🇴",
    alpha3: "ROU"
  },
  RS: {
    code: "RS",
    unicode: "U+1F1F7 U+1F1F8",
    name: "Serbia",
    emoji: "🇷🇸",
    alpha3: "SRB"
  },
  RU: {
    code: "RU",
    unicode: "U+1F1F7 U+1F1FA",
    name: "Russia",
    emoji: "🇷🇺",
    alpha3: "RUS"
  },
  RW: {
    code: "RW",
    unicode: "U+1F1F7 U+1F1FC",
    name: "Rwanda",
    emoji: "🇷🇼",
    alpha3: "RWA"
  },
  SA: {
    code: "SA",
    unicode: "U+1F1F8 U+1F1E6",
    name: "Saudi Arabia",
    emoji: "🇸🇦",
    alpha3: "SAU"
  },
  SB: {
    code: "SB",
    unicode: "U+1F1F8 U+1F1E7",
    name: "Solomon Islands",
    emoji: "🇸🇧",
    alpha3: "SLB"
  },
  SC: {
    code: "SC",
    unicode: "U+1F1F8 U+1F1E8",
    name: "Seychelles",
    emoji: "🇸🇨",
    alpha3: "SYC"
  },
  SD: {
    code: "SD",
    unicode: "U+1F1F8 U+1F1E9",
    name: "Sudan",
    emoji: "🇸🇩",
    alpha3: "SDN"
  },
  SE: {
    code: "SE",
    unicode: "U+1F1F8 U+1F1EA",
    name: "Sweden",
    emoji: "🇸🇪",
    alpha3: "SWE"
  },
  SG: {
    code: "SG",
    unicode: "U+1F1F8 U+1F1EC",
    name: "Singapore",
    emoji: "🇸🇬",
    alpha3: "SGP"
  },
  SH: {
    code: "SH",
    unicode: "U+1F1F8 U+1F1ED",
    name: "St. Helena",
    emoji: "🇸🇭",
    alpha3: "SHN"
  },
  SI: {
    code: "SI",
    unicode: "U+1F1F8 U+1F1EE",
    name: "Slovenia",
    emoji: "🇸🇮",
    alpha3: "SVN"
  },
  SJ: {
    code: "SJ",
    unicode: "U+1F1F8 U+1F1EF",
    name: "Svalbard & Jan Mayen",
    emoji: "🇸🇯",
    alpha3: "SJM"
  },
  SK: {
    code: "SK",
    unicode: "U+1F1F8 U+1F1F0",
    name: "Slovakia",
    emoji: "🇸🇰",
    alpha3: "SVK"
  },
  SL: {
    code: "SL",
    unicode: "U+1F1F8 U+1F1F1",
    name: "Sierra Leone",
    emoji: "🇸🇱",
    alpha3: "SLE"
  },
  SM: {
    code: "SM",
    unicode: "U+1F1F8 U+1F1F2",
    name: "San Marino",
    emoji: "🇸🇲",
    alpha3: "SMR"
  },
  SN: {
    code: "SN",
    unicode: "U+1F1F8 U+1F1F3",
    name: "Senegal",
    emoji: "🇸🇳",
    alpha3: "SEN"
  },
  SO: {
    code: "SO",
    unicode: "U+1F1F8 U+1F1F4",
    name: "Somalia",
    emoji: "🇸🇴",
    alpha3: "SOM"
  },
  SR: {
    code: "SR",
    unicode: "U+1F1F8 U+1F1F7",
    name: "Suriname",
    emoji: "🇸🇷",
    alpha3: "SUR"
  },
  SS: {
    code: "SS",
    unicode: "U+1F1F8 U+1F1F8",
    name: "South Sudan",
    emoji: "🇸🇸",
    alpha3: "SSD"
  },
  ST: {
    code: "ST",
    unicode: "U+1F1F8 U+1F1F9",
    name: "São Tomé & Príncipe",
    emoji: "🇸🇹",
    alpha3: "STP"
  },
  SV: {
    code: "SV",
    unicode: "U+1F1F8 U+1F1FB",
    name: "El Salvador",
    emoji: "🇸🇻",
    alpha3: "SLV"
  },
  SX: {
    code: "SX",
    unicode: "U+1F1F8 U+1F1FD",
    name: "Sint Maarten",
    emoji: "🇸🇽",
    alpha3: "SXM"
  },
  SY: {
    code: "SY",
    unicode: "U+1F1F8 U+1F1FE",
    name: "Syria",
    emoji: "🇸🇾",
    alpha3: "SYR"
  },
  SZ: {
    code: "SZ",
    unicode: "U+1F1F8 U+1F1FF",
    name: "Swaziland",
    emoji: "🇸🇿",
    alpha3: "SWZ"
  },
  TA: {
    code: "TA",
    unicode: "U+1F1F9 U+1F1E6",
    name: "Tristan da Cunha",
    emoji: "🇹🇦"
  },
  TC: {
    code: "TC",
    unicode: "U+1F1F9 U+1F1E8",
    name: "Turks & Caicos Islands",
    emoji: "🇹🇨",
    alpha3: "TCA"
  },
  TD: {
    code: "TD",
    unicode: "U+1F1F9 U+1F1E9",
    name: "Chad",
    emoji: "🇹🇩",
    alpha3: "TCD"
  },
  TF: {
    code: "TF",
    unicode: "U+1F1F9 U+1F1EB",
    name: "French Southern Territories",
    emoji: "🇹🇫",
    alpha3: "ATF"
  },
  TG: {
    code: "TG",
    unicode: "U+1F1F9 U+1F1EC",
    name: "Togo",
    emoji: "🇹🇬",
    alpha3: "TGO"
  },
  TH: {
    code: "TH",
    unicode: "U+1F1F9 U+1F1ED",
    name: "Thailand",
    emoji: "🇹🇭",
    alpha3: "THA"
  },
  TJ: {
    code: "TJ",
    unicode: "U+1F1F9 U+1F1EF",
    name: "Tajikistan",
    emoji: "🇹🇯",
    alpha3: "TJK"
  },
  TK: {
    code: "TK",
    unicode: "U+1F1F9 U+1F1F0",
    name: "Tokelau",
    emoji: "🇹🇰",
    alpha3: "TKL"
  },
  TL: {
    code: "TL",
    unicode: "U+1F1F9 U+1F1F1",
    name: "Timor-Leste",
    emoji: "🇹🇱",
    alpha3: "TLS"
  },
  TM: {
    code: "TM",
    unicode: "U+1F1F9 U+1F1F2",
    name: "Turkmenistan",
    emoji: "🇹🇲",
    alpha3: "TKM"
  },
  TN: {
    code: "TN",
    unicode: "U+1F1F9 U+1F1F3",
    name: "Tunisia",
    emoji: "🇹🇳",
    alpha3: "TUN"
  },
  TO: {
    code: "TO",
    unicode: "U+1F1F9 U+1F1F4",
    name: "Tonga",
    emoji: "🇹🇴",
    alpha3: "TON"
  },
  TR: {
    code: "TR",
    unicode: "U+1F1F9 U+1F1F7",
    name: "Turkey",
    emoji: "🇹🇷",
    alpha3: "TUR"
  },
  TT: {
    code: "TT",
    unicode: "U+1F1F9 U+1F1F9",
    name: "Trinidad & Tobago",
    emoji: "🇹🇹",
    alpha3: "TTO"
  },
  TV: {
    code: "TV",
    unicode: "U+1F1F9 U+1F1FB",
    name: "Tuvalu",
    emoji: "🇹🇻",
    alpha3: "TUV"
  },
  TW: {
    code: "TW",
    unicode: "U+1F1F9 U+1F1FC",
    name: "Taiwan",
    emoji: "🇹🇼",
    alpha3: "TWN"
  },
  TZ: {
    code: "TZ",
    unicode: "U+1F1F9 U+1F1FF",
    name: "Tanzania",
    emoji: "🇹🇿",
    alpha3: "TZA"
  },
  UA: {
    code: "UA",
    unicode: "U+1F1FA U+1F1E6",
    name: "Ukraine",
    emoji: "🇺🇦",
    alpha3: "UKR"
  },
  UG: {
    code: "UG",
    unicode: "U+1F1FA U+1F1EC",
    name: "Uganda",
    emoji: "🇺🇬",
    alpha3: "UGA"
  },
  UM: {
    code: "UM",
    unicode: "U+1F1FA U+1F1F2",
    name: "U.S. Outlying Islands",
    emoji: "🇺🇲",
    alpha3: "UMI"
  },
  UN: {
    code: "UN",
    unicode: "U+1F1FA U+1F1F3",
    name: "United Nations",
    emoji: "🇺🇳"
  },
  US: {
    code: "US",
    unicode: "U+1F1FA U+1F1F8",
    name: "United States",
    emoji: "🇺🇸",
    alpha3: "USA"
  },
  UY: {
    code: "UY",
    unicode: "U+1F1FA U+1F1FE",
    name: "Uruguay",
    emoji: "🇺🇾",
    alpha3: "URY"
  },
  UZ: {
    code: "UZ",
    unicode: "U+1F1FA U+1F1FF",
    name: "Uzbekistan",
    emoji: "🇺🇿",
    alpha3: "UZB"
  },
  VA: {
    code: "VA",
    unicode: "U+1F1FB U+1F1E6",
    name: "Vatican City",
    emoji: "🇻🇦",
    alpha3: "VAT"
  },
  VC: {
    code: "VC",
    unicode: "U+1F1FB U+1F1E8",
    name: "St. Vincent & Grenadines",
    emoji: "🇻🇨",
    alpha3: "VCT"
  },
  VE: {
    code: "VE",
    unicode: "U+1F1FB U+1F1EA",
    name: "Venezuela",
    emoji: "🇻🇪",
    alpha3: "VEN"
  },
  VG: {
    code: "VG",
    unicode: "U+1F1FB U+1F1EC",
    name: "British Virgin Islands",
    emoji: "🇻🇬",
    alpha3: "VGB"
  },
  VI: {
    code: "VI",
    unicode: "U+1F1FB U+1F1EE",
    name: "U.S. Virgin Islands",
    emoji: "🇻🇮",
    alpha3: "VIR"
  },
  VN: {
    code: "VN",
    unicode: "U+1F1FB U+1F1F3",
    name: "Vietnam",
    emoji: "🇻🇳",
    alpha3: "VNM"
  },
  VU: {
    code: "VU",
    unicode: "U+1F1FB U+1F1FA",
    name: "Vanuatu",
    emoji: "🇻🇺",
    alpha3: "VUT"
  },
  WF: {
    code: "WF",
    unicode: "U+1F1FC U+1F1EB",
    name: "Wallis & Futuna",
    emoji: "🇼🇫",
    alpha3: "WLF"
  },
  WS: {
    code: "WS",
    unicode: "U+1F1FC U+1F1F8",
    name: "Samoa",
    emoji: "🇼🇸",
    alpha3: "WSM"
  },
  XK: {
    code: "XK",
    unicode: "U+1F1FD U+1F1F0",
    name: "Kosovo",
    emoji: "🇽🇰"
  },
  YE: {
    code: "YE",
    unicode: "U+1F1FE U+1F1EA",
    name: "Yemen",
    emoji: "🇾🇪",
    alpha3: "YEM"
  },
  YT: {
    code: "YT",
    unicode: "U+1F1FE U+1F1F9",
    name: "Mayotte",
    emoji: "🇾🇹",
    alpha3: "MYT"
  },
  ZA: {
    code: "ZA",
    unicode: "U+1F1FF U+1F1E6",
    name: "South Africa",
    emoji: "🇿🇦",
    alpha3: "ZAF"
  },
  ZM: {
    code: "ZM",
    unicode: "U+1F1FF U+1F1F2",
    name: "Zambia",
    emoji: "🇿🇲",
    alpha3: "ZMB"
  },
  ZW: {
    code: "ZW",
    unicode: "U+1F1FF U+1F1FC",
    name: "Zimbabwe",
    emoji: "🇿🇼",
    alpha3: "ZWE"
  }
};

// The file src/pages/Checkout/Address/PaymentInfo/index.tsx` doesn't have the
// strings requested by the interface, and at the moment they're not the best
// option to keep this info, since it has another specific responsibilities

export type Cards = {
  key: string;
  name: string;
};

const paymentCards: Cards[] = [
  {
    key: "credit_card",
    name: "Credit Card"
  },
  {
    key: "rh_gift",
    name: "RH Gift Card"
  },
  {
    key: "rh_rc",
    name: "RH Rewards Certificate"
  },
  {
    key: "rh_credit",
    name: "RH Credit Card"
  }
];

export type Months = {
  key: string;
  name: string;
  number: string;
};

const months: Months[] = [
  {
    key: "jan",
    name: "January",
    number: "01"
  },
  {
    key: "feb",
    name: "February",
    number: "02"
  },
  {
    key: "mar",
    name: "March",
    number: "03"
  },
  {
    key: "apr",
    name: "April",
    number: "04"
  },
  {
    key: "may",
    name: "May",
    number: "05"
  },
  {
    key: "jun",
    name: "June",
    number: "06"
  },
  {
    key: "jul",
    name: "July",
    number: "06"
  },
  {
    key: "aug",
    name: "August",
    number: "08"
  },
  {
    key: "sep",
    name: "September",
    number: "09"
  },
  {
    key: "oct",
    name: "October",
    number: "10"
  },
  {
    key: "nov",
    name: "November",
    number: "11"
  },
  {
    key: "dec",
    name: "December",
    number: "12"
  }
];

const getMappedTranslatedNames = (
  countriesData: Record<string, string>
): Country[] => {
  return Object.keys(countriesData).map(code => ({
    ...countries[code],
    name: countriesData[code]
  }));
};

const getTranslatedCountryNames = (
  preferred: string[] = [],
  exclude: string[] = [],
  translatedCountryNames?: Record<string, string>
): Country[] => {
  const countriesList = translatedCountryNames
    ? getMappedTranslatedNames(translatedCountryNames)
    : Object.values(countries);

  const preferredCountries = preferred.map(c =>
    countriesList.find(country => country.code === c)
  );

  const restCountries = countriesList.filter(
    c => !exclude.includes(c.code) && !preferred.includes(c.code)
  );

  return [...preferredCountries, ...orderBy(restCountries, ["name"], ["asc"])];
};

const getOrderedCountries = (
  preferred: string[] = [],
  exclude: string[] = [],
  translatedCountryNames?: Record<string, string>
): Country[] => {
  return translatedCountryNames
    ? getTranslatedCountryNames(preferred, exclude, translatedCountryNames)
    : [
        ...preferred.map(c => countries[c]),
        ...orderBy(
          Object.values(countries).filter(
            c => !exclude.includes(c.code) && !preferred.includes(c.code)
          ),
          ["name"],
          ["asc"]
        )
      ];
};

const countryList = getOrderedCountries(
  ["US", "CA", "GB"],
  ["USA", "CAN", "GBR"]
);

const statesMap = {
  US: usStates,
  CA: caStates,
  GB: gbStates
};

const countriesWithZipCodeList = ["US", "CA"];

const getCountryByCode = countryCode => {
  return Object.values(countries).find(item => item.code === countryCode);
};
export const AVAILABLE_COUNTRIES_CODES = ["CA", "US", "GB", "DE"];

export const withSpecialCharacters = ({
  allowSpecials,
  baseRegex,
  specialCharsRegex = specialCharactersRegex
}: {
  allowSpecials: boolean;
  baseRegex: RegExp;
  specialCharsRegex?: RegExp;
}) => {
  if (!allowSpecials) return baseRegex;

  const specialCharsRegexSanitized = specialCharsRegex.source.slice(2, -3);
  const baseRegexSanitized = baseRegex.source.slice(2, -3);

  const mergedPattern = new RegExp(
    `^((?:${specialCharsRegexSanitized})|(?:${baseRegexSanitized}))*$`
  );

  return mergedPattern;
};

export {
  countries,
  usStates,
  gbStates,
  caStates,
  statesMap,
  allAvailableStates,
  paymentCards,
  months,
  countryList,
  countriesWithZipCodeList,
  getOrderedCountries,
  getCountryByCode
};
